import { sendPageviewEvent, sendArticleRefTags, sendArticleHashtags } from '../scripts/tagmanager';
import { initiliazeArticleEvents, initiliazeEntryEvents } from '../scripts/articleEvents';
import { sendOnedioPanelCounter, sendOnedioSRVHit } from '../scripts/hit';
import {
  sendDataLayer,
  getPageType,
  sendMenuImpressionEvent,
  sendMenuClickEvent,
  clearMenuImpressionTimer,
  mapArticleData,
  sendWidgetEvent,
  sendVideoWidgetEvent,
  sendUAGALayers,
} from '../scripts/dataLayer';
export const useTracking = () => {
  return {
    sendPageviewEvent,
    sendOnedioSRVHit,
    sendOnedioPanelCounter,
    initiliazeArticleEvents,
    initiliazeEntryEvents,
    sendDataLayer,
    mapArticleData,
    sendArticleRefTags,
    getPageType,
    sendMenuImpressionEvent,
    sendMenuClickEvent,
    clearMenuImpressionTimer,
    sendArticleHashtags,
    sendWidgetEvent,
    sendVideoWidgetEvent,
    sendUAGALayers,
  };
};
